
export default function () {
    const errorStyleClass = (v$, field) => {
        return null != v$[field] && v$[field].$invalid && v$[field].$dirty ? 'p-invalid' : '';
    }

    return {errorStyleClass}
}
